import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import TextTranslate from "../../../utils/TextTranslate";

export default function CreateGroupHeader() {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-20 shrink-0 border-b border-black/[0.06] bg-secondary/85 backdrop-blur-xl dark:border-white/[0.08]">
      <div className="flex items-center justify-between px-3 py-3">
        <button
          type="button"
          aria-label="Back"
          className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
          onClick={() => navigate(-1)}
        >
          <IoChevronBack className="text-xl" />
        </button>
        <span className="text-[17px] font-semibold tracking-tight text-darkText">
          <TextTranslate text="New Group" />
        </span>
        <div className="h-9 w-9" aria-hidden />
      </div>
    </div>
  );
}
